import {
  Box,
  Icon,
  Step,
  StepDescription,
  StepIndicator,
  Stepper,
  StepStatus,
  StepTitle,
  VStack,
} from "@chakra-ui/react";
import { RiCheckLine } from "@remixicon/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { RegisterEmailForm } from "../../components/register_page/RegisterEmailForm";
import { RegisterOtpForm } from "../../components/register_page/RegisterOtpForm";
import { RegisterPasswordForm } from "../../components/register_page/RegisterPasswordForm";
import useScreenWidth from "../../lib/useScreenWidth";
import { MetaTag } from "../../utils/MetaTag";

const steps = [
  { title: "Email", description: "Daftarkan emaiil" },
  { title: "OTP", description: "Verifikasi OTP" },
  { title: "Password", description: "Atur password akun" },
];

export const Register = () => {
  const [activeStep, setActiveStep] = useState<number>(0);
  const location = useLocation();
  const sw = useScreenWidth();

  const queryParams = new URLSearchParams(location.search);
  const registerStep = queryParams.get("step") || "";

  useEffect(() => {
    switch (registerStep) {
      case "otp":
        setActiveStep(1);
        break;
      case "password":
        setActiveStep(2);
        break;
      default:
        setActiveStep(0);
    }
  }, [registerStep]);

  const stepEmailComp = () => <RegisterEmailForm url="" />;
  const stepOtpComp = () => <RegisterOtpForm url="" />;
  const stepPasswordComp = () => <RegisterPasswordForm url="" />;

  return (
    <VStack p={4} justify={"space-between"}>
      <MetaTag
        title="Buat Akun | BisnisLink"
        description="Daftarkan email, verifikasi OTP, dan atur password untuk membuat akun BisnisLink."
      />

      <Stepper index={activeStep} colorScheme="red" gap={8}>
        {steps.map((step, i) => (
          <Step key={i}>
            <StepIndicator>
              <StepStatus
                complete={<Icon as={RiCheckLine} />}
                incomplete={i + 1}
                active={i + 1}
              />
            </StepIndicator>

            <Box flexShrink={sw > 768 ? (sw < 1000 ? undefined : 0) : 0}>
              <StepTitle>
                <Box
                  as="span"
                  fontSize={[12, null, 14]}
                  fontWeight={"semibold"}
                >
                  {step.title}
                </Box>
              </StepTitle>
              <StepDescription>
                <Box as="span" fontSize={[10, null, 12]} fontWeight={"normal"}>
                  {step.description}
                </Box>
              </StepDescription>
            </Box>
          </Step>
        ))}
      </Stepper>

      {activeStep === 1
        ? stepOtpComp()
        : activeStep === 2
        ? stepPasswordComp()
        : stepEmailComp()}

      <VStack></VStack>
    </VStack>
  );
};
